import chatReducer from "./chatSlice.js";
import { configureStore } from "@reduxjs/toolkit";
import fireReducer from "./fireSlice.js";

const store = configureStore({
  reducer: {
    chat: chatReducer,
    fire: fireReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: [
          'chat/setUser', 
          'fire/checkAndCreateUser/pending',
          'fire/checkAndCreateUser/fulfilled',
          'fire/getOrCreateUser'
        ],
        // Ignore these field paths in all actions
        ignoredActionPaths: ['payload.user', 'meta.arg'],
        // Ignore these paths in the state
        ignoredPaths: ['chat.user'],
      },
    }),
});

export default store;
